import {RelationshipsModel} from "../../../models/responses/relationships.model";

export const getRelationshipsForSpecificTask = (relationshipsList: RelationshipsModel[], taskId: string) => {
    return relationshipsList.filter(task => task.task_id === taskId);
};
